'use client';

export default function AboutHero() {
  return (
    <section className="rounded-[28px] bg-[#F7F1E6] p-6 sm:p-8 md:rounded-[36px] md:p-14">
      <div className="mx-auto flex max-w-[1040px] flex-col gap-5 text-center">
        <span className="text-sm uppercase tracking-[0.25em] text-[#7F6B48]">
          Mộc Phúc Duyên since 2026
        </span>
        <h1 className="text-2xl font-bold text-[#223A27] sm:text-3xl md:text-5xl">
          Hành trình trà tinh túy, giữ lại hương vị Việt
        </h1>
        <p className="mx-auto max-w-2xl text-sm leading-7 text-[#5C5A52] sm:text-base md:text-lg md:leading-8">
          Mộc Phúc Duyên mang đến trải nghiệm thưởng trà tinh tế, trọn vẹn từ nguồn nguyên liệu sạch đến phong cách phục vụ đậm chất truyền thống. Chúng tôi tạo nên không gian trà dành cho những ai yêu cái đẹp đơn sơ, an yên và hương vị tự nhiên.
        </p>
      </div>
    </section>
  );
}
